import type ServiceError from './ServiceError';

export class AlertDetailedInfo {
  public title: string;
  public messages: string[] = [];

  public get hasDetails(): boolean {
    return this.messages?.length > 0;
  }

  public toString(): string {
    if (this.hasDetails) {
      return `${this.title}: ${this.messages.join(', ')}`;
    }
    return this.title;
  }

  static fromApiError(error: ServiceError): AlertDetailedInfo {
    const alert = new AlertDetailedInfo();
    alert.title = error?.title;
    // Set message only the title and message should be different
    error?.title !== error?.message && (alert.messages = [error?.message].filter(Boolean));
    return alert;
  }

  static from(title: string, message: string): AlertDetailedInfo {
    const alert = new AlertDetailedInfo();
    alert.title = title;
    alert.messages = [message];
    return alert;
  }
}
